import React from 'react'
import { I18n } from '@front/volcanion'

import { Typography, Grid, Box } from '@mui/material'
import { ModelMenuSelectorField } from '@front/squirtle'

import CPUtils from '@front/squirtle/utils/CPUtils'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('authorized_package.search')} </Typography>
  </Grid>

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='commercialpackage'
        label={I18n.t('commercialpackage.label', { count: -1 })}
        model_name='commercialpackage'
        config={{
          mutator: cp => ({ ...CPUtils.getTranslatedLabel(cp), ...cp })
        }}
        searchMode={'search'}
        loadOnMount
        multiple
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'commercialformula'}
        model_name='commercialformula'
        label={I18n.t('commercialformula.label', { count: -1 })}
        labelKeys={['name']}
        searchMode='search'
        loadOnMount
        multiple
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'mode'}
        model_name='ridemode'
        label={I18n.t('ride.label', { count: -1 })}
        labelKeys={['name_translated']}
        searchMode='search'
        config={{ sort: ['display_index ASC'] }}
        loadOnMount
        multiple
      />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 {...props} />
    </Grid>
  </Box>

export default React.memo(SearchForm)
